
<h1>{{ title }}</h1>
<div>{{ subtitle }}</div>
<mat-icon [class]="type">{{ getTypeIcon() }}</mat-icon>
<ng-content></ng-content>